import React from "react";
import { IconButton, Box, Typography } from "@mui/material";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import NotificationsIcon from "@mui/icons-material/Notifications";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from '@mui/icons-material/Logout';
import alpaagoIcon from "../../assets/Images/aplaago.png";
import "./TopBar.css";

const TopBar = ({ fullSideBar, setFullSideBar, handleLogout }) => {
  return (
    <Box
      component="header"
      sx={{
        width: "100%",
        height: "60px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        px: 2,
        fontFamily: "Montserrat",
      }}
    >
      {/* Left Section: Menu + Logo */}
      <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
        <IconButton
          onClick={() => setFullSideBar((prev) => !prev)}
          sx={{ height: "fit-content" }}
        >
          {fullSideBar ? (
            <MenuOpenIcon sx={{ fontSize: 30, color: "black" }} />
          ) : (
            <MenuRoundedIcon sx={{ fontSize: 30, color: "black" }} />
          )}
        </IconButton>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1, ml: -2 }}>
          <img
            src={alpaagoIcon}
            alt="AlpaaGO"
            style={{ width: 40, height: 40 }}
          />
          <Typography variant="h6" sx={{ fontWeight: 700, color: "#271340" }}>
            AlpaaGO
          </Typography>
        </Box>
      </Box>

      {/* Right Section: Action Buttons */}
      <Box sx={{ display: "flex", alignItems: "center" }}>
        {/* Uncomment if you want other icons */}
        {/*
        <IconButton sx={{ p: 1 }}>
          <SettingsIcon sx={{ fontSize: 26, color: "#5E6E82" }} />
        </IconButton>
        <IconButton sx={{ p: 1 }}>
          <NotificationsIcon sx={{ fontSize: 26, color: "#5E6E82" }} />
        </IconButton>
        <IconButton sx={{ p: 1 }}>
          <AccountCircleIcon sx={{ fontSize: 40, color: "#5E6E82" }} />
        </IconButton>
        */}
        <IconButton onClick={handleLogout} sx={{ mr: 2 }}>
          <LogoutIcon sx={{ fontSize: 26, color: "black" }} />
        </IconButton>
      </Box>
    </Box>
  );
};

export default TopBar;
